// Auto-generated by scripts/translate-i18n-ja.ts — do not edit by hand.
const data: any = {
  rt: {
    "b": {
      "thisOpponent": "この相手",
      "firstMatch": "初対戦",
      "lastMatch": "前回の対戦 · {{value}}",
      "oneRated": "{{name}}戦 {{value}} · 評価済み1試合",
      "average": "{{name}}戦 {{value}} · {{count}}試合",
      "oneRatedMe": "自分との対戦 {{value}} · 評価済み1試合",
      "averageMe": "自分との対戦 {{value}} · {{count}}試合",
      "comparisonControls": "過去との比較",
      "showH2H": "直接対戦の平均",
      "showOverall": "全試合の総合平均"
    },
    "f": {
      "shot_accuracy": "ショットの正確性",
      "call_accuracy": "自分のイン／アウト判定の正確さ",
      "confrontational_tendency": "対立の起こしやすさ",
      "forehand": "フォアハンド",
      "backhand": "バックハンド",
      "service": "サーブ",
      "return": "リターン",
      "volley": "ボレー",
      "smash": "スマッシュ",
      "drop_shot": "ドロップショット",
      "lob": "ロブ",
      "stamina": "スタミナ",
      "speed": "スピード",
      "court_coverage": "コートカバー",
      "tactics": "戦術",
      "awareness": "状況判断",
      "shot_variety": "ショットの多彩さ",
      "winners": "ウィナー",
      "unforced_errors": "アンフォーストエラー",
      "fh_topspin": "フォアのトップスピン",
      "fh_slice": "フォアのスライス",
      "bh_topspin": "バックのトップスピン",
      "bh_slice": "バックのスライス",
      "first_serve": "ファーストサーブ",
      "first_serve_speed": "ファーストサーブの速度",
      "second_serve": "セカンドサーブ",
      "second_serve_speed": "セカンドサーブの速度",
      "serve_flat": "フラットサーブ",
      "serve_kick": "キックサーブ",
      "serve_slice": "スライスサーブ",
      "first_serve_pct_est": "ファーストサーブ確率（推定）",
      "second_serve_pct_est": "セカンドサーブ確率（推定）",
      "passing_shots": "パッシングショット",
      "volley_d": "ボレー",
      "tactics_d": "戦術",
      "speed_d": "スピード",
      "stamina_d": "スタミナ",
      "composure": "平常心",
      "concentration": "集中力",
      "calmness": "落ち着き",
      "anxiety": "不安",
      "confidence": "自信",
      "fighting_spirit": "闘志",
      "mental_resilience": "精神的な回復力",
      "belief_pre": "試合前の勝利への自信",
      "belief_in": "試合中の勝利への自信"
    },
    "g": {
      "movement": "動き・ポジショニング",
      "behaviour": "振る舞い",
      "forehand": "フォアハンド",
      "backhand": "バックハンド",
      "serve": "サーブ",
      "rally": "ラリーとリターン",
      "net": "ネットプレー",
      "physical": "フィジカルと戦術"
    },
    "h": {
      "shot_accuracy": "狙った場所にどれくらい安定して打てましたか？",
      "call_accuracy": "自分のイン／アウト判定はどれくらい正確だったと思いますか？",
      "confrontational_tendency": "相手との口論・緊張・対立の起こしやすさ。"
    },
    "dist": {
      "winnersIncl": "ウィナー（エース含む）",
      "unforcedIncl": "アンフォーストエラー（ダブルフォルト含む）",
      "assignTo": "残り {{n}}% を割り当て…",
      "countHint": "エース{{a}}本、ダブルフォルト{{d}}本を記録しました。",
      "remainingInline": "残り {{n}}%",
      "complete": "完了 — 100% 配分済み",
      "assignRemainder": "残りの {{n}}% をここに割り当てる",
      "tab": "ポイント",
      "title": "ポイントはどう決まった？",
      "helper": "あなたの感覚での推定でかまいません。1ポイントずつ記録する必要はなく、空欄のままでもOKです。",
      "winners": "ウィナー",
      "forced": "フォーストエラー",
      "unforced": "アンフォーストエラー",
      "df": "ダブルフォルト",
      "total": "合計",
      "remaining": "未割り当て {{n}}%",
      "over": "100%超過 {{n}}%",
      "myTeam": "自分のペア",
      "oppTeam": "相手ペア"
    }
  },
  "onboarding": {
    "heading": "あなたのテニス記録を築き始めよう",
    "description": "数分で試合を記録し、傾向を追いかけ、統計が次に何を改善すべきかを教えてくれます。",
    "eyebrow": "はじめに",
    "valueHistory": "試合の記録をすべて残す",
    "valueStats": "自分の統計を理解する",
    "valueImprove": "上達の推移を追いかける",
    "showMore": "使い方と機能",
    "showLess": "閉じる",
    "headlineDashboard": "あなたのダッシュボードは、最初の試合記録を待っています。",
    "headlineMatches": "試合を記録して、あなたのテニスヒストリーを始めましょう",
    "headlineStats": "統計データは、最初の試合後にアンロックされます。",
    "intro": "Tennis Logは、あなたがプレーする全ての試合を貴重なデータに変えます。最初の試合は1分もかからずに記録でき、ダッシュボードや各種チャート、AIコーチが動き出す様子をご覧ください。",
    "cta": "+ 最初の試合を記録する",
    "howTitle": "使い方",
    "s1Title": "試合を追加する",
    "s1Desc": "「新しい試合」をタップし、日付、対戦相手、コート、セットスコアを入力します。ドロップダウンで素早く入力できます。",
    "s2Title": "詳細を追加（任意）",
    "s2Desc": "Fast Trackで必要事項を保存してから、Score Timeline、Opponent、Context、Performance Review、Smartwatchを通じて、必要なだけ詳細を追加できます。",
    "s3Title": "統計データを見る",
    "s3Desc": "ウィンレート、サービスホールド率、ブレーク率、セット、ゲーム、サーフェス、コート、対戦相手など、あらゆるデータが即座に更新されます。",
    "s4Title": "AIによる分析を得る",
    "s4Desc": "AI分析は試合データを記録すると利用でき、試合履歴が増えるほど、一般的により有益な内容になります。",
    "benefitsTitle": "試合を記録すると見えてくること",
    "b1Title": "総合ウィンレート",
    "b1Desc": "年別、フォーマット（シングルス／ダブルス／ミックス）、種類（練習／公式戦）でフィルターできます。シーズンごとの傾向を把握しましょう。",
    "b2Title": "セット、ゲーム、ホールド率＆ブレーク率",
    "b2Desc": "勝敗だけでなく、サービスゲームをどれだけキープできたか、どれだけブレークできたか、セットの得失差、ゲームのバランスなどを確認できます。",
    "b3Title": "スマートウォッチのデータ",
    "b3Desc": "Mi Fitness、Garmin、Apple Watch、Zeppのスクリーンショットを1枚アップロードするだけで、AIが消費カロリー、BPM（心拍数）、心拍ゾーンを自動入力します。",
    "b4Title": "ゲームごとのヒートマップ",
    "b4Desc": "第3ゲームで崩れやすいか、第11ゲームをきっちり締めくくれるかなど、サーブ側・リターン側、セットごとに分析して、あなたの傾向を発見できます。",
    "b5Title": "パフォーマンス評価",
    "b5Desc": "フォアハンド、バックハンド、サーブ、リターン、ボレー、状況判断力、コートカバーリングなどを評価します。レーダーチャートで視覚的に確認できます。",
    "b6Title": "AIコーチ",
    "b6Desc": "あなたの強み、弱み、プレースタイルを、まるで専属コーチのように、データに基づいて文章で解説します。",
    "tipsTitle": "最初の記録のヒント",
    "tip1": "まずはシンプルに。日付、対戦相手、セットスコアだけでも十分です。",
    "tip2": "コートとサーフェスも追加してみましょう。時間が経つにつれ、どのコートが得意かが見えてきます。",
    "tip3": "1セットだけでもゲームごとに記録してみましょう。サービスホールド率やゲームごとのヒートマップがアンロックされます。",
    "tip4": "自己評価は正直に。数回の入力だけでもAIコーチの分析に役立ちます。",
    "tip5": "過去の試合結果も思い出しましたか？それも記録しましょう。履歴が多ければ多いほど、統計は正確になります。"
  },
  "nav": {
    "dashboard": "ダッシュボード",
    "matches": "試合",
    "add": "試合の記録",
    "stats": "スタッツ",
    "insights": "AIインサイト",
    "logout": "サインアウト",
    "settings": "設定",
    "invite": "友達を招待"
  },
  "brand": {
    "name": "My Tennis Ledger",
    "tagline": "試合履歴を分析して、もっと上達しましょう。"
  },
  "auth": {
    "age16": "16歳以上であることを確認します。Tennis Log のアカウントは16歳以上の方が対象です。",
    "age16Required": "16歳以上であることをご確認ください。",
    "signIn": "ログイン",
    "signUp": "新規登録",
    "email": "メールアドレス",
    "password": "パスワード",
    "name": "名前",
    "createAccount": "アカウントを作成",
    "or": "または",
    "continueGoogle": "Googleで続ける",
    "welcomeBack": "おかえりなさい！",
    "accountCreated": "アカウントが作成されました！",
    "passwordInfoLabel": "パスワードの要件",
    "passwordHelp": "8文字以上で入力してください。大文字・数字・記号は必須ではありませんが、ごく一般的で推測されやすいパスワードは避けてください。既知の情報漏えいに含まれるパスワードは使用できません。",
    "passwordTooShort": "パスワードは8文字以上である必要があります。", "passwordWeakLeaked": "このパスワードは一般的すぎるか、既知の情報漏えいに含まれています。より固有のパスワードをお試しください。", "passwordRejected": "このパスワードは受け付けられませんでした。入力欄の横の要件を確認して、もう一度お試しください。", "passwordMinLabel": "8文字以上", "requirementMet": "要件を満たしています", "requirementNotMet": "要件をまだ満たしていません",
    "sameMethodHint": "アカウント作成時と同じサインイン方法を使用してください。",
    "signInFailed": "メールアドレスまたはパスワードが正しくありません。Googleでアカウントを作成した場合は、Googleでサインインしてください。"
  },
  "authPage": {
    "heroTitle": "あなたのテニスの歴史を築き始めよう",
    "heroSubtitle": "数分で試合を記録し、自分のパターンを把握し、次に何を改善すべきかを統計に語らせましょう。",
    "trustFree": "主要機能は無料",
    "trustData": "あなたのデータはあなたのもの",
    "trustDevice": "スマホでもウェブでも動作",
    "dashboardAlt": "勝率、セット、ゲーム、ホールド率を表示するTennis Logのダッシュボード",
    "dashboardCaption": "数試合を記録すると、ダッシュボードに勝率、ホールド率、ブレークポイント、傾向、AIインサイトが表示され始めます。",
    "founderQuote": "自分の試合を忘れてしまうのが嫌で、Tennis Logを作りました。必要なのは、プレーして、スコアの流れを覚えて、記録することだけ。きっとあなたにも役立つはずです。楽しんでください！",
    "founderTitle": "Tennis Log — My Tennis Ledger 創設者",
    "founderLocation": "上級クラブレベルプレイヤー、ギリシャ",
    "notReadyTitle": "まだ登録する準備ができていませんか？",
    "notReadySub": "まずは公開コンテンツを見てみましょう — すべてオープン、アカウント不要です。",
    "viewDemoTitle": "公開デモを見る",
    "viewDemoDesc": "約25試合後のTennis Logが何を明らかにするか、実際のグラフで確認できます。",
    "readGuideTitle": "テニス統計ガイドを読む",
    "readGuideDesc": "本当に大切な統計と、その読み方。",
    "browseBlogTitle": "ブログを見る",
    "browseBlogDesc": "ホールド/ブレーク、勝率トレンド、スマートウォッチ、AIインサイト、メンタルに関する記事。",
    "open": "開く"
  },
  "common": {
    "all": "すべて",
    "singles": "シングルス",
    "doubles": "ダブルス",
    "mixed": "ミックス",
    "friendly": "練習試合",
    "official": "公式戦",
    "me": "自分",
    "opponent": "相手",
    "year": "年",
    "draw": "引き分け",
    "cancel": "キャンセル",
    "save": "保存",
    "saving": "保存中…",
    "loading": "読み込み中…",
    "delete": "削除",
    "edit": "編集",
    "search": "検索",
    "close": "閉じる",
    "matches": "試合",
    "other": "その他（具体的に入力）",
    "loadFailed": "データを読み込めませんでした",
    "loadFailedBody": "読み込み中に問題が発生しました。接続を確認してもう一度お試しください。",
    "retry": "再試行"
  },
  "conditions": {
    "sun": "眩しい日差し",
    "wind": "風",
    "noise": "騒音・周囲の音",
    "cold": "寒さ",
    "rain": "雨",
    "slippery": "滑りやすいコート",
    "humidity": "湿度の高さ",
    "strong_wind": "強風"
  },
  "dashboard": {
    "title": "ダッシュボード",
    "subtitle": "シーズン成績が一目でわかります。",
    "newMatch": "+ 新しい試合",
    "statsFilter": "スタッツフィルター",
    "trendFilter": "トレンドフィルター",
    "trendTitle": "ウィンレートの推移",
    "recent": "最近の試合",
    "seeAll": "すべて →",
    "noMatches": "まだ試合がありません。",
    "addFirst": "最初の試合を追加しましょう",
    "noFilter": "このフィルターに一致する試合はありません。",
    "overallWinRate": "総合ウィンレート",
    "winRate": "ウィンレート",
    "clickDot": "点をクリックして試合を編集",
    "sets": "セット",
    "games": "ゲーム",
    "holdRate": "サービスキープ率",
    "breaksWon": "ブレーク獲得数",
    "breaksWonSub": "リターンゲーム{{total}}回中{{breaks}}回",
    "serviceGames": "サービスゲーム",
    "returnGames": "リターンゲーム",
    "winAfterFirstSet": "第1セット先取後の勝率",
    "winAfterFirstSetSub": "{{total}}試合中{{wins}}勝",
    "surfaceFilter": "サーフェス",
    "setsWon": "獲得セット率",
    "gamesWon": "獲得ゲーム率",
    "breakRate": "ブレーク率",
    "currentForm": "現在の調子",
    "formEmpty": "完了した試合がまだありません",
    "trendDelta": "ウィンレート 直近10試合で{{pp}}ポイント",
    "trendStable": "ウィンレートは直近10試合で横ばい",
    "trendUnavailable": "トレンドは{{count}}試合後に表示されます",
    "discovery": {
      "title": "あなたのテニスが教えてくれること",
      "family": { "improving": "改善中", "edge": "あなたの強み", "watch": "要注意" }
    }
  },
  "match": {
    "opponentPrivacyHint": "任意です。相手選手に関する情報です。ご自身の分析に役立つ事実のみを記録してください。",
    "invalidSetScore": "セット{{set}}のスコアが不正です — 勝者は規定のスコアに達し、2差以上でリードする必要があります。",
    "basics": "基本情報",
    "players": "選手",
    "score": "セットごとのスコア",
    "notes": "メモ",
    "watch": "スマートウォッチのデータ",
    "rating": "試合の評価（1〜10）",
    "surface": "サーフェス",
    "temperature": "気温（°C）",
    "setType": "セットの種類",
    "standardSet": "スタンダード",
    "shortSet": "ショートセット（4ゲーム先取）",
    "superTb": "スーパータイブレーク（10p）",
    "tb7": "タイブレーク 7p",
    "tb11": "タイブレーク 11p",
    "tbPointByPoint": "ポイントごと",
    "tbUndo": "元に戻す",
    "tbClear": "クリア",
    "tbDecided": "決定",
    "date": "日付",
    "time": "時間",
    "day": "曜日",
    "court": "コート",
    "courtCustomPlaceholder": "例：クラブコート1番",
    "format": "試合形式",
    "kind": "試合の種類",
    "set": "セット",
    "firstServer": "最初のサーバー：",
    "missingOpponent": "対戦相手の名前を入力すると保存できます。",
    "missingCourt": "コート名を入力すると保存できます。",
    "opponentRequired": "対戦相手 *",
    "myPartner": "自分のパートナー",
    "oppPartner": "相手のパートナー",
    "teams": "チーム",
    "teamsHint": "自チーム（自分＋パートナー）対 相手チーム（対戦相手1＋対戦相手2）。",
    myTeam: "自分のチーム",
    opponentTeam: "相手チーム",
    opponent1: "対戦相手1",
    opponent2: "対戦相手2",
    doublesPlayersRequired: "ダブルスを保存するには、パートナーと相手2人の名前を入力してください。",
    "age": "年齢",
    "experience": "経験年数",
    "backhand": "バックハンド",
    "playstyle": "プレースタイル",

    "notesPlaceholder": "試合はどうでしたか？",
    "summaryTab": "概要",
    "detailedTab": "詳細",
    "watchHint": "Mi Fitness、Garmin、Apple Watchのスクリーンショットをアップロードすると、AIが自動で項目を埋めます。",
    "ratingHint": "評価したくない項目は空欄のままにしてください。",
    "saveMatch": "試合を保存",
    "saveChanges": "変更を保存",
    "addTitle": "新しい試合",
    "addSubtitle": "詳細を入力します。ドロップダウンで素早く入力できます。",
    "editTitle": "試合を編集",
    "editSubtitle": "詳細を更新して保存します。",
    "saved": "試合が保存されました！",
    "changesSaved": "変更が保存されました！",
    "notFound": "試合が見つかりません",
    "retired": "棄権はありましたか？",
    "retiredNone": "いいえ",
    "retiredYes": "はい",
    specialEnding: "特殊な試合終了",
    scoreMismatchTitle: "スコアが一致しません",
    scoreMismatchBody: "記録したゲーム経過からは {{derived}} になりますが、最終スコアは {{declared}} です。続ける前に確認してください。",
    scoreMismatchFix: "最終スコアを修正",
    declaredScore: "入力した最終スコア",
    declaredScoreHint: "これはステップ1で入力した最終スコアです。次に、セットがどのように進んだかを記録してください。",
    declaredScorePrompt: "<highlight>セット{{set}}の最終スコアを{{score}}と入力しました</highlight>。次に、そのスコアに至る流れを記録してください。",
    incompleteSetTimePrompt: "<highlight>セット{{set}}は{{score}}まで進んだ</highlight>と入力されていますが、完了していません。時間切れになった可能性があります。Eloに反映するため、実際に行われたgamesだけを入力してください。",
    timelineLiveScore: "ゲームごとの現在のスコア",
    scoreMismatchBlock: "ゲームごとのスコアが最終スコアと一致していません。続ける前に修正してください。",
    gameSequenceNext: "ゲームは順番に入力してください · 次: Game {{game}}",
    gameSequenceGap: "Game {{later}} の前に Game {{missing}} が未入力です。先に入力してください。",
    gameSequenceBlock: "続ける前に、抜けているゲームを順番どおり入力してください。",
    "retiredMe": "自分が棄権",
    "retiredOpp": "相手が棄権",
    "doubleFaults": "ダブルフォルト",
    "dfMe": "自分のダブルフォルト",
    "dfOpp": "相手のダブルフォルト",
    "aces": "エース",
    "acesMe": "自分のエース",
    "acesOpp": "相手のエース",
    "context": "状況とコンディション",
    "contextHint": "プレーに影響した可能性のある外的・個人的な要因。",
    "conditions": "身体的なコンディション",
    "personalIssues": "個人的な問題",
    "personalIssuesPlaceholder": "例：頭痛、膝の痛み、時差ボケ…",
    "psychTab": "心理面",
    "oppAge": "相手の年齢",
    "oppBackhand": "相手のバックハンド",
    "bhSingle": "片手",
    "bhDouble": "両手",
    "oppPlaystyle": "プレースタイル",
    "styleOffensive": "攻撃的",
    "styleDefensive": "守備的",
    "styleAllCourt": "オールコート",
    "floodlights": "ナイター",
    "rainy": "雨天",
    "tiringDay": "疲れた日/仕事が大変だった日",
    "napped": "昼寝をした",
    "heavyMeal": "重い食事",
    "fasted": "空腹だった",
    "anxiousFlag": "不安だった",
    "tournamentRound": "大会のラウンド",
    "tournamentName": "大会名",
    "sleepHours": "昨夜の睡眠時間（時間）",
    "ballsState": "ボールの状態",
    "ballsNew": "新品",
    "ballsUsed": "使用済み",
    "ballsUseCount": "使用回数",
    "ballsUseSuffix": "回",
    "oppExperience": "テニス歴（年）",
    "racketStrungAt": "ガットの張り替え日",
    "racketStrungAgo": "{{n}}日前",
    "racketStrungToday": "今日",
    "individualConditions": "個人的なコンディション",
    "daysSinceLastMatch": "最後の試合からの日数",
    "daysAgo": "{{n}}日前",
    "ballsUsed1": "1回使用",
    "ballsUsed2": "2回使用",
    "ballsUsed3": "3回使用",
    "oppHandedness": "利き手",
    "righty": "右利き",
    "lefty": "左利き",
    "weightKg": "体重 ({{unit}})",
    "bmi": "BMI",
    "bmiNoHeight": "プロフィールで身長を設定するとBMIが計算されます",
    "hLegend": "H = ホールド",
    "bLegend": "B = ブレーク",
    "cellHowTo": "サーバーのセルを1回タップでホールド（H）、もう一度タップでブレーク（B）。さらにタップでクリアします。",
    "gameDetail": {
      "toggle": "ゲームごとの詳細を追加",
      "toggleHint": "任意：終了したゲームをタップして、敗者が到達した正確なポイントを記録できます。",
      "gameN": "第{{n}}ゲーム",
      "openSheet": "詳細を追加",
      "youServed": "自分のサーブ", "oppServed": "相手のサーブ",
      "held": "キープ", "wasBroken": "ブレークされた", "oppHeld": "相手がキープ", "youBroke": "ブレークした",
      "question": "ゲームを落とした側はどこまで取りましたか？",
      "deuce": "デュース",
      "gamePointQuestion": "落とした側にゲームポイントはありましたか？",
      "yes": "はい", "no": "いいえ",
      "clearDetail": "詳細をクリア", "changeResult": "結果を変更",
      "hold": "キープ", "break": "ブレーク", "clearResult": "結果をクリア",
      "token": { "0": "0まで", "15": "15まで", "30": "30まで", "D": "デュース、ゲームポイントなし", "DG": "デュース、ゲームポイントあり" }
    },
  },
  "matches": {
    "title": "試合",
    "subtitle": "全ての試合履歴。フィルター機能で絞り込んだり、詳しく見ることができます。",
    "searchOpponent": "対戦相手を検索",
    "searchPlaceholder": "例: 山田",
    "format": "種目",
    "confrontation": "区分",
    "matchesCount": "{{count}}試合",
    "none": "試合がありません",
    "new": "+ 新規",
    "setGameByGame": "第{{n}}セット — ゲーム毎の進行",
    "confirmDelete": "試合を削除しますか？この操作は元に戻せません。",
    "deleted": "削除しました",
    "singular": "シングルス",
    "duplet": "ダブルス",
    "official": "公式戦",
    "friendly": "練習試合"
  },
  "stats": {
    "perGameSelectionDetails": "記録された{{total}}ゲーム中{{wins}}ゲーム成功",
    "trendSelectedMatch": "選択した試合",
    "trendOpenMatch": "試合を見る",
    "tempStepLabel": "気温区間 (°C)",
    "ageStepLabel": "年齢区間（年）",
    "experienceStepLabel": "経験年数区間（年）",
    "byMyBmiHint": "BMI = 体重(kg) ÷ 身長²(m²)。プロフィールの身長と試合ごとの体重から計算します。",
    "byMyBmiNone": "BMIデータがありません。設定で身長を、試合ごとに体重を入力してください。",
    "bmiBucketSize": "BMI区間",
    "bmiSmallSampleHint": "棒をタップすると勝利数と試合数が分かります。少数の試合による細かい区間は信頼できる傾向を示しません。",
    "startTimeHalfHourHint": "開始時刻を30分ごとに集計（18:30は18:30〜18:59）。",
    "title": "スタッツ",
    "subtitle": "詳細なデータ分析",
    "none": "スコアが記録された試合はまだありません。",
    "allOpponents": "すべての対戦相手",
    "byOppLevel": "対戦相手のレベル別勝率",
    "byOppLevelHint": "相手の総合的な強さ（1〜10）。",
    "byOppLevelNone": "対戦相手のレベルはまだ記録されていません。",
    "serviceStats": "サービススタッツ",
    "returnStats": "リターンスタッツ",
    "holds": "ホールド",
    "breaksAgainst": "被ブレーク",
    "holdRate": "ホールド率 ({{n}} ゲーム)",
    "gamesIServed": "サービスゲーム",
    "holdRateOnServe": "自分のサーブでのホールド率",
    "gamesIReceived": "リターンゲーム",
    "opponentHolds": "相手のホールド",
    "breaksIDid": "獲得したブレーク",
    "breaksWon": "獲得したブレーク",
    "breakRate": "ブレーク率 ({{n}} リターンゲーム)",
    "smartwatch": "スマートウォッチのスタッツ",
    "smartwatchHint": "ウォッチのスクリーンショットから算出した平均値です。",
    "avgKcal": "平均消費カロリー",
    "avgDuration": "平均時間",
    "avgBpm": "平均BPM",
    "maxBpm": "最大BPM (平均)",
    "perfReport": "パフォーマンスレポート",
    "perfHint": "評価を付けた全試合の平均評価（1～10）です。",
    "perfNone": "まだ評価を追加していません。",
    "trendTitle": "ウィンレートの推移",
    "h2h": "直接対決",
    "byCourt": "コート別ウィンレート",
    "byDay": "曜日別ウィンレート",
    "bySurface": "サーフェス別ウィンレート",
    "byTemp": "気温別ウィンレート",
    "surfaceNone": "サーフェスがまだ記録されていません。",
    "tempNone": "気温がまだ記録されていません。",
    "perGame": "ゲームごとの成功率",
    "set": "セット",
    "scope": "集計対象",
    "scopeAll": "全体",
    "scopeServing": "サーブ開始",
    "scopeReturning": "レシーブ開始",
    "metricWin": "ウィンレート",
    "metricHold": "ホールド率 (サーブ時)",
    "fullTab": "全体",
    "allSet": "全セット",
    "perGameHint": "ゲーム番号ごとの成功率です。",
    "firstBreakTitle": "先にブレークした側別 勝率",
    "firstBreakHint": "最初のブレークが結果を左右しますか？",
    "fbMe": "自分が先にブレーク",
    "fbOpp": "相手が先にブレーク",
    "allSurfaces": "すべてのサーフェス",
    "firstServerTitle": "先攻サーブ別 勝率",
    "firstServerHint": "サーブ先行が結果に影響しますか？",
    "fsMatch": "試合全体",
    "fsMe": "自分がサーブ開始",
    "fsOpp": "相手がサーブ開始",
    "returnGames": "リターンゲーム",
    "breakRateLabel": "ブレーク率",
    "gameNumber": "ゲーム",
    "hrZonesAvg": "平均心拍ゾーン",
    "hrZonesAvgHint": "ウォッチデータのある{{n}}試合における、各ゾーンの平均滞在時間（分）です。",
    "byYear": "年別ウィンレート",
    "byMonth": "月別ウィンレート",
    "byCategoryKind": "カテゴリー・種類別ウィンレート",
    "byOppAge": "相手の年齢別ウィンレート",
    "byOppAgeHint": "年齢層ごとに分類しています。",
    "byOppAgeNone": "相手の年齢がまだ記録されていません。",
    "byOppExp": "相手の経験年数別ウィンレート",
    "byOppExpHint": "テニスのプレー年数です。",
    "byOppExpNone": "相手の経験年数がまだ記録されていません。",
    "byOppBmi": "相手のBMI別ウィンレート",
    "byOppBmiHint": "ボディマス指数 = 体重(kg) / 身長²(m²)",
    "byOppBmiNone": "相手のBMIデータがまだ記録されていません。このチャートを表示するには、相手の身長と体重を追加してください。",
    "showTrend": "推移を表示",
    "hideTrend": "推移を非表示",
    "byOppBackhand": "相手のバックハンド別ウィンレート",
    "byOppBackhandNone": "相手のバックハンドがまだ記録されていません。",
    "byBalls": "ボールの状態別ウィンレート",
    "byBallsNone": "ボールの状態がまだ記録されていません。",
    "ballsNew": "新品", "ballsUsed": "使用済", "ballsUsedN": "使用済 ×{{count}}",

    "byRainy": "雨天時ウィンレート",
    "byFloodlights": "ナイター時ウィンレート",
    "byDuration": "試合時間別ウィンレート",
    "byStartTime": "開始時間別ウィンレート",
    "byMyBmi": "自分のBMI別ウィンレート",
    "byOppHandedness": "相手の利き手別ウィンレート",
    "byOppPlaystyle": "相手のプレースタイル別ウィンレート",
    byOppBirthMonth: "対戦相手の生まれ月別の勝率",
    "bySleep": "睡眠時間別ウィンレート",
    "byTiringDay": "疲れた翌日のウィンレート",
    "byNapped": "昼寝ありのウィンレート",
    "byHeavyMeal": "食後（重い食事）のウィンレート",
    "byFasted": "空腹時のウィンレート",
    "byAnxious": "緊張時のウィンレート",
    "byCondition": "身体コンディション別ウィンレート",
    "byPartner": "パートナー別ウィンレート",
    "gameDetail": {
      "whenServing": "自分のサービス時", "whenReturning": "自分のリターン時",
      "held": "キープ", "broken": "ブレークされた", "opponentHeld": "相手がキープ", "iBroke": "自分がブレーク",
      "deuce": "デュース", "pressure": "プレッシャー",
      "serviceCoverage": "サービスゲーム{{total}}件中{{detailed}}件に詳細あり",
      "returnCoverage": "リターンゲーム{{total}}件中{{detailed}}件に詳細あり",
      "smallSample": "少ないサンプル · n={{count}}",
      "noServiceData": "詳細付きサービスゲームはまだありません", "noReturnData": "詳細付きリターンゲームはまだありません",
      "unlock": "試合記録時にゲーム詳細を追加すると、この内訳を確認できます。",
      "serviceTooltip": "{{percentage}}% · 詳細付きサービスゲーム{{total}}件中{{count}}件",
      "returnTooltip": "{{percentage}}% · 詳細付きリターンゲーム{{total}}件中{{count}}件",
      "serviceHeld": { "0": "リターナーを0でキープ", "15": "リターナーを15でキープ", "30": "リターナーを30でキープ", "D": "デュース後にキープ", "DG": "ブレークポイントをしのいでキープ" },
      "serviceBroken": { "0": "0でブレークされた", "15": "15でブレークされた", "30": "30でブレークされた", "D": "デュース後にブレークされた", "DG": "ゲームポイントを得た後にブレークされた" },
      "returnHeld": { "0": "自分が0で相手がキープ", "15": "自分が15で相手がキープ", "30": "自分が30で相手がキープ", "D": "デュース後に相手がキープ", "DG": "自分にブレークポイントがあった後に相手がキープ" },
      "returnBreak": { "0": "相手を0でブレーク", "15": "相手を15でブレーク", "30": "相手を30でブレーク", "D": "デュース後にブレーク", "DG": "相手にゲームポイントがあった後にブレーク" }
    }
  },
  "theme": {
    "label": "テーマ",
    "court": "コート(夜)",
    "clay": "クレー",
    "daylight": "デイライト",
    "grass": "グラス",
    "hardcourt": "ハードコート"
  },
  "insights": {
    "pageSubtitle": "AIによる試合分析。",
    "pickOpponent": "対戦相手",
    "title": "インサイト",
    "subtitle": "あなたのデータから見えてくる傾向と AIコーチ",
    "askAi": "AIに質問",
    "generating": "生成中…",
    "aiNarrative": "AIによる解説",
    "notEnough": "データがまだ不足しています。試合の記録を続けましょう。",
    "aiError": "AIインサイトを生成できませんでした。"
  },
  "insightsPreview": {
    "title": "Tennis Log がこれから見つけること",
    "subtitle": "試合を記録していくと、Tennis Log があなたの結果の背景にある傾向を少しずつ学習します。",
    "learningTitle": "Tennis Log が次に学習すること",
    "learningSubtitle": "これらの項目については、判断できるようになるまでもう少し試合の記録が必要です。",
    "examplesLabel": "Tennis Log が見つけられることの例",
    "badge": "例",
    "cta": "最初の試合を記録する",
    "disclaimer": "これらは説明のための例であり、あなたに関する結論ではありません。あなたのデータに基づくものではありません。",
    "items": {
      "serve": { "text": "ファーストサーブの調子が良いとき、接戦での勝率が高くなる。", "unlock": "いくつかの試合でサーブの評価を記録すると解放されます。" },
      "opponents": { "text": "格上の相手に対する結果が良くなってきている。", "unlock": "相手のレベルを含む試合をもう少し記録すると解放されます。" },
      "pressure": { "text": "プレッシャーの高いセットでアンフォーストエラーが増える。", "unlock": "もう少し試合を記録すると、プレッシャーの影響が分かります。" },
      "surface": { "text": "特定のサーフェスでの勝率が他より高い。", "unlock": "異なるサーフェスでの試合を記録すると解放されます。" },
    },
  },
  "gaps": {
    "title": "Tennis Log がまだ知らないこと",
    "subtitle": "試合の記録が充実するほど、あなた専用のAIコーチは賢くなります。",
    "knowledgeTitle": "AIの理解度",
    "knowledgeHint": "意味のあるAI分析に使える情報がどれだけ揃っているかの目安です。",
    "loggedIn": "試合の {{pct}}% で記録されています。",
    "notYet": "まだデータがありません。",
    "couldReveal": "Tennis Log が見つけられること:",
    "cta": "記録を始める",
    "doneTitle": "素晴らしい！",
    "doneBody": "Tennis Log はすでに質の高いAIインサイトを作れるだけのデータを持っています。記録を続けると精度が上がり、新しい長期的な傾向が見えてきます。",
    "items": {
      "selfRatings": {
        "label": "自己評価",
        "bullets": ["どのショットが試合を決めているか", "セットごとの調子の変化", "シーズンを通した成長"],
      },
      "opponentRatings": {
        "label": "相手の評価",
        "bullets": ["格上相手に効く強み", "同レベル相手にだけ出る弱み", "相手別のマッチアップ分析"],
      },
      "sleep": {
        "label": "睡眠",
        "bullets": ["睡眠が勝率に与える影響", "スタミナ", "第3セットのパフォーマンス"],
      },
      "nutrition": {
        "label": "食事",
        "bullets": ["食事がパフォーマンスに与える影響", "重い食事と安定性の関係", "空腹時のスタミナの変化"],
      },
      "weather": {
        "label": "天候・コンディション",
        "bullets": ["日差し・風・雨によるプレーの変化", "ナイター照明でのパフォーマンス", "得意な気温帯"],
      },
      "court": {
        "label": "コート・ボール",
        "bullets": ["得意なサーフェス", "ボールの状態とリズムの関係", "相性の良い会場"],
      },
      "emotions": {
        "label": "メンタルと体調",
        "bullets": ["緊張が接戦のセットに与える影響", "疲れた日の影響", "冷静さが試合を変える場面"],
      },
      "watch": {
        "label": "スマートウォッチ",
        "bullets": ["疲労の検出", "回復パターン", "心拍数と強度の相関"],
      },
    }
  },
  coach: {
    driverTitle: "勝敗を左右する要素",
    driverLead: "良いときも悪いときも試合を左右している要素があります：{{topic}}。",
    driverSupport: "これまで：うまくいった試合は{{goodSample}}試合中{{goodWins}}勝（{{goodRate}}%）、そうでない試合は{{badSample}}試合中{{badWins}}勝（{{badRate}}%）です。",
    title: "AIコーチ・サマリー",
    subtitle: "Tennis Log が試合から学んだ最も重要なポイント。",
    notEnough: "まだ結論を出すには試合数が足りません — 記録を続けましょう。",
    strengthTitle: "最大の強み",
    weaknessTitle: "最大の弱点",
    possibleStrengthTitle: "強みの可能性",
    possibleWeaknessTitle: "改善の余地がありそうな点",
    strengthLead: "データが示す最大の強み: {{topic}}",
    weaknessLead: "データが示す最大の弱点: {{topic}}",
    strengthLeadTentative: "強みの兆しがあります: {{topic}} — ただしサンプル数はまだ少なめです。",
    weaknessLeadTentative: "改善の余地がありそうです: {{topic}} — ただしサンプル数はまだ少なめです。",
    focusTitle: "次の試合のフォーカス",
    focusOne: "次の試合ではここに集中: {{first}}",
    focusTwo: "次の試合ではここに集中: {{first}} — 安定した武器として維持: {{second}}",
    disclaimer: "これはあなたのデータから見えた傾向であり、因果関係の証明ではありません。",
    confidence: {
      high: "信頼度：高",
      medium: "信頼度：中",
      low: "信頼度：低",
    },
  },
  composite: {
    title: "複合インサイト",
    subtitle: "複数のシグナルを組み合わせて初めて見えるパターン。",
    disclaimer: "複合インサイトはあなたのデータ内の相関を示すもので、証明された原因ではありません。サンプル数と差が十分な場合のみ表示されます。",
    showMore: "さらに {{count}} 件表示",
    showLess: "表示を減らす",
    direction: {
      positive: "ポジティブな結果",
      negative: "ネガティブな結果",
      neutral: "中立的な結果",
    },
    cat: {
      momentum: "流れ・モメンタム",
      context: "条件別のパフォーマンス",
      opponent: "対戦相手の分析",
      physical: "コンディション",
      development: "成長",
      matchup: "マッチアップ分析",
    },
    ev: {
      groups: "{{aLabel}}は {{aSample}} 試合中 {{aWins}} 勝（{{aRate}}%）、{{bLabel}}は {{bSample}} 試合中 {{bWins}} 勝（{{bRate}}%）。",
      single: "{{aSample}} 試合中 {{aWins}} 勝（{{aRate}}%）。",
      ratingTrend: "直近 {{recentN}} 試合の自己評価平均は {{recentAvg}}、その前の {{prevN}} 試合は {{prevAvg}}。",
    },
    grp: {
      metricAbove: "この項目で自己評価が平均を上回った試合（{{skill}}）",
      metricBelow: "評価が平均以下だった試合",
      metricAboveSurface: "{{surface}}でこの項目の自己評価が平均を上回った試合（{{skill}}）",
      metricBelowSurface: "{{surface}}で評価が平均以下だった試合",
      lostFirstSet: "第1セットを落とした試合",
      wonFirstSet: "第1セットを取った試合",
      long: "90分を超える試合",
      short: "90分未満の試合",
      decider: "最終セットまでもつれた試合",
      overall: "記録した全試合",
      tiebreak: "タイブレークがあった試合",
      surfaceOn: "このサーフェス（{{surface}}）",
      surfaceOff: "その他のサーフェス",
      morning: "午前の試合",
      afternoon: "午後・夜の試合",
      floodlit: "ナイター照明下",
      daylight: "日中",
      skillBetter: "この項目（{{skill}}）で自分の評価が上だった試合",
      skillWorse: "その項目で相手の評価が上だった試合",
      goodSleepLong: "7時間以上の睡眠後の長い試合",
      lowSleepLong: "睡眠が少なかった長い試合",
      goodSleepDecider: "7時間以上の睡眠後の最終セットまでの試合",
      lowSleepDecider: "睡眠が少なかった最終セットまでの試合",
      heavyMeal: "重い食事の後",
      noHeavyMeal: "重い食事なし",
      recentPeriod: "直近 {{n}} 試合",
      previousPeriod: "その前の {{n}} 試合",
      h2hLostFirst: "この相手に第1セットを落とした試合",
      h2hOverall: "この相手との全対戦",
    },
    msg: {
      mentalPressureStrong: "プレッシャー場面ではメンタルが勝敗を分けています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      mentalPressureWeak: "プレッシャー場面でメンタルが失点につながっています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      serveTightStrong: "競ったセットではサーブが効いています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      serveTightWeak: "競ったセットでサーブの弱点が出ています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      techniqueSurfaceStrong: "{{surface}}では特定の要素が結果を左右しています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      techniqueSurfaceWeak: "{{surface}}では特定の要素が足かせになっています（{{skill}}）— 自己評価が平均を上回った試合は{{sample}}試合中{{wins}}勝（{{rate}}%）、そうでない試合は{{otherSample}}試合中{{otherWins}}勝（{{otherRate}}%）です。",
      comebackStrong: "第1セットを落としても立て直せています — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）。",
      comebackWeak: "第1セットを落とすと現状は苦戦しています — 該当 {{sample}} 試合中 {{wins}} 勝のみ（{{rate}}%）。",
      fadeLong: "長い試合で失速しています — 90分超の {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、短い試合は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      thriveLong: "長い試合が合っています — 90分超の {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、短い試合は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      deciderStrong: "最終セットでレベルが上がります — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全体の {{baseline}}% を上回ります。",
      deciderWeak: "最終セットで取りこぼしています — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全体の {{baseline}}% を下回ります。",
      tiebreakStrong: "タイブレークが味方しています — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全体の {{baseline}}% を上回ります。",
      tiebreakWeak: "タイブレークで落としています — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全体の {{baseline}}% を下回ります。",
      surfaceStrong: "得意なサーフェス: {{surface}} — {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、他は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      surfaceWeak: "苦手なサーフェス: {{surface}} — {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、他は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      morningBetter: "午前の試合が最も安定しています — {{sample}} 中 {{wins}} 勝（{{rate}}%）、午後以降は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      eveningBetter: "午後以降のほうが安定しています — {{sample}} 中 {{wins}} 勝（{{rate}}%）、午前は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      floodlightsBetter: "ナイターでも崩れません — {{sample}} 中 {{wins}} 勝（{{rate}}%）、日中は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      floodlightsWorse: "ナイターは苦戦しています — {{sample}} 中 {{wins}} 勝（{{rate}}%）、日中は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      strongOppSkill: "格上相手では勝敗を分ける項目: {{skill}} — 自分の評価が上だった {{sample}} 試合中 {{wins}} 勝（{{rate}}%）。",
      strongOppWeak: "格上相手では一項目の優位だけでは足りません: {{skill}} — {{sample}} 試合中 {{wins}} 勝（{{rate}}%）。",
      peerOppSkill: "同レベルの相手で優位になる項目: {{skill}} — {{sample}} 試合中 {{wins}} 勝（{{rate}}%）。",
      sleepLongMatches: "長い試合では睡眠が結果に表れます — 7時間以上で {{sample}} 中 {{wins}} 勝（{{rate}}%）、少ない場合は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      fatigueThirdSet: "最終セットまでの試合では — 7時間以上の睡眠で {{sample}} 中 {{wins}} 勝（{{rate}}%）、少ない場合は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      mealStrongOpp: "格上相手では重い食事の影響が出ています — 重い食事なしで {{sample}} 中 {{wins}} 勝（{{rate}}%）、ありでは {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      skillRising: "上向きの項目: {{skill}} — 直近 {{sample}} 試合で約 +{{diff}} 評価ポイント。",
      skillFalling: "下向きの項目: {{skill}} — 直近 {{sample}} 試合で約 -{{diff}} 評価ポイント。",
      formUp: "最近の調子は上向き — 直近 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、その前の {{otherSample}} 試合は {{otherWins}} 勝（{{otherRate}}%）。相手のレベルは同程度です。",
      formDown: "最近の調子は下降 — 直近 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、その前の {{otherSample}} 試合は {{otherWins}} 勝（{{otherRate}}%）。相手のレベルは同程度です。",
      matchupSkill: "{{opponent}} との対戦で勝敗を分ける項目: {{skill}} — 自分の評価が上だった {{sample}} 試合中 {{wins}} 勝（{{rate}}%）。",
      matchupFirstSet: "{{opponent}} には第1セットを落とすと厳しい — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全対戦は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
      matchupComeback: "{{opponent}} には第1セットを落としても問題ありません — 該当 {{sample}} 試合中 {{wins}} 勝（{{rate}}%）、全対戦は {{otherSample}} 中 {{otherWins}} 勝（{{otherRate}}%）。",
    },
  },
  "watch": {
    "uploadScreenshot": "スクリーンショットをアップロード",
    "uploading": "アップロード中...",
    "aiExtracting": "AIがデータを抽出中...",
    "removeImage": "画像を削除",
    "imageRequired": "画像を選択 (PNG/JPG)",
    "uploadFailed": "アップロードに失敗しました",
    "extractFailed": "AIによる抽出に失敗しました",
    "extracted": "スクリーンショットからデータを抽出しました！",
    "sourcesHint": "Mi Fitness、Garmin、Apple Watch、Zeppなどから。AIが自動で項目を埋めます。",
    multipleHint: "スクリーンショットは複数枚アップロードできます。",
    "screenshotAlt": "スマートウォッチのワークアウト画面のスクリーンショット",
    "kcal": "消費カロリー (kcal)",
    "duration": "時間 (分)",
    "avgBpm": "平均心拍数 (BPM)",
    "maxBpm": "最大心拍数 (BPM)",
    "hrZones": "心拍ゾーン",
    "notes": "ウォッチのメモ",
    "notesPlaceholder": "トレーニング効果、リカバリーなど"
  },
  "surfaces": {
    "hard": "ハード",
    "clay": "クレー",
    "grass": "グラス",
    "carpet": "カーペット"
  },
  "ad": {
    "label": "広告"
  },
  "footer": {
    "rights": "全著作権所有。",
    "contact": "お問い合わせ",
    "contactTitle": "Tennis Ledgerへのお問い合わせ",
    "contactHint": "メッセージをお送りください。いただいたメールアドレス宛に返信いたします。",
    "yourEmail": "メールアドレス",
    "subject": "件名",
    "message": "お問い合わせ内容",
    "send": "メールを作成する",
  },
  "install": {
    "iosCta": "iPhoneにインストール",
    "platforms": "Android対応 · iPhoneでも使えます",
    "iosSheetTitle": "Tennis Logをアプリのように使う",
    "iosSheetIntro": "App Storeなしで、数タップでホーム画面に追加できます。",
    "iosSheetStep1": "SafariでTennis Logを開く",
    "iosSheetStep2": "共有ボタンをタップ",
    "iosSheetStep3": "「ホーム画面に追加」をタップ",
    "iosSheetStep4": "「追加」をタップ",
    "iosReassurance": "Tennis Logがホーム画面に表示され、アプリのように起動します。",
    "iosNonSafari": "iPhoneにTennis Logをインストールするには、このページをSafariで開いてください。",
    "iosNonSafariHint": "ブラウザのメニューから「Safariで開く」を選び、共有 →「ホーム画面に追加」を実行してください。",
    "iosNudgeTitle": "Tennis Logをワンタップの場所に",
    "iosNudgeBody": "ホーム画面に追加すると、アプリのように使えます。",
    "iosNudgeShowMe": "方法を見る",
    "iosNudgeDismiss": "今はしない",
    "cta": "アプリをインストール",
    "loading": "インストールオプションを読み込み中です。数秒お待ちください。",
    "opening": "インストール画面を開いています…",
    "unavailable": "現在、インストールオプションは利用できません。",
    "title": "Tennis Log をインストール",
    "hint": "Tennis Logをあなたの端末に追加すると、通常のアプリのように開くことができます。",
    "iosStep1": "共有をタップ",
    "iosStep2": "次に「ホーム画面に追加」を選択します。",
    "iosStep3": "右上の「追加」をタップ",
    "androidStep1": "ブラウザのメニュー ⋮ をタップ",
    "androidStep2": "「アプリをインストール」または「ホーム画面に追加」を選択します。",
    "androidStep3": "インストールを確定",
    "desktopHint": "デスクトップ版 Chrome または Edge では:",
    "desktopStep1": "アドレスバーのインストールアイコンをクリックします",
    "desktopStep2": "または、ブラウザのメニューを開いて「Tennis Logをインストール」を選択します。"
  },
  "profileSetup": {
    "title": "プレーヤープロフィールを完成させる",
    "subtitle": "いくつかの情報で、統計とAI分析の精度が大きく上がります。",
    "dob": "生年月日",
    "level": "あなたのレベル（1〜10）",
    "levelHint": "1＝始めたばかり、10＝ハイレベルな競技プレーヤー。",
    "unitsMetric": "メートル法",
    "unitsUs": "米国",
    "later": "あとで",
    "saved": "プロフィールを更新しました",
    "ctaTitle": "プレーヤープロフィールを完成させる",
    "ctaBody": "1分ほどで、統計のすべての比較がより正確になります。",
    "ctaAction": "プロフィールを完成",
    "countryPlaceholder": "国を選択",
    "countrySearch": "国を検索…",
    "countryEmpty": "該当する国がありません"
  },
  "settings": {
    "healthConsent": "健康データの同意",
    "healthConsentActive": "有効：試合に追加した健康データの処理を許可しています。",
    "healthConsentInactive": "無効：スマートウォッチおよび心拍データは処理されません。",
    "healthConsentWithdraw": "同意を撤回",
    "healthConsentWithdrawn": "同意を撤回し、健康データを削除しました。",
    "healthConsentPartial": "同意を撤回しました。一部の健康データはまだ削除できていません。しばらくしてから再試行してください。",
    "healthConsentError": "同意を更新できませんでした。もう一度お試しください。",
    "healthConsentWithdrawHint": "同意を撤回すると、保存されているスマートウォッチのスクリーンショットとインポート済みの健康データ（心拍数、消費カロリーなど）が完全に削除されます。",
    "healthConsentWithdrawTitle": "健康データの同意を撤回しますか？",
    "healthConsentWithdrawBody": "保存されているスマートウォッチのスクリーンショットと、試合に保存されている心拍数・消費カロリーなどの健康データが完全に削除されます。この操作は取り消せません。",
    "healthConsentWithdrawKeepMatches": "試合記録自体は残ります。削除されるのは保存されているスマートウォッチと健康関連データのみです。",
    "healthConsentWithdrawConfirm": "同意を撤回して健康データを削除",
    "title": "設定",
    "profile": "プロフィール",
    "displayName": "表示名",
    "age": "年齢",
    "country": "国",
    "gender": "性別",
    "gender_male": "男性",
    "gender_female": "女性",
    "gender_other": "その他",
    "gender_prefer_not": "回答しない",
    "level": "テニスのレベル",
    "level_beginner": "初級",
    "level_intermediate": "中級",
    "level_advanced": "上級",
    "level_competitive": "競技レベル",
    "profileSaved": "プロフィールを保存しました",
    "password": "パスワード",
    "newPassword": "新しいパスワード",
    "changePassword": "パスワードを変更",
    "pwdTooShort": "パスワードは6文字以上で設定してください",
    "pwdChanged": "パスワードを変更しました",
    "dataExport": "データのエクスポート",
    "dataExportHint": "全{{count}}試合のデータをCSVファイルとしてダウンロードします。",
    "exportCsv": "CSV形式でエクスポート",
    "noMatchesExport": "エクスポートする試合がまだありません。",
    "exported": "{{count}}試合をエクスポートしました",
    "units": "単位",
    "unitsHint": "気温と体重の表示単位を選択します。データは常に°Cとkgで保存されます。",
    "unitsMetric": "メートル法 (°C, kg)",
    "unitsUs": "米国単位 (°F, lb)",
    "cookiePrefs": "Cookieの設定",
    "cookiePrefsHint": "許可するCookieのカテゴリーを更新します。",
    "manageCookies": "Cookieを管理",
    "diagnostics": "アプリと診断",
    "diagnosticsHint": "問題を再現するのに役立つ技術情報です。個人情報は含まれません。",
    "diagnosticsCopy": "診断情報をコピー",
    "diagnosticsCopied": "診断情報をクリップボードにコピーしました",
    "diagnosticsCopyFailed": "コピーできませんでした — もう一度お試しください",
    "reportProblem": "問題を報告",
    "diagnosticsPasted": "診断情報をコピーしました — メッセージに貼り付けてください。",
    "diagLanguage": "言語",
    "diagUnits": "単位",
    "diagDisplay": "表示モード",
    "diagDisplayStandalone": "インストール済みアプリ（スタンドアロン）",
    "diagDisplayBrowser": "ブラウザタブ",
    "diagBrowser": "ブラウザ",
    "diagViewport": "ビューポート",
    "diagOrientation": "向き",
    "diagHostname": "ホスト名",
    "dangerZone": "危険な操作",
    "deleteAccount": "アカウントを削除",
    "deleteHint": "アカウントと全ての試合データを完全に削除します。この操作は元に戻すことができません。",
    "deleteConfirmTitle": "アカウントを削除しますか？",
    "deleteConfirmDesc": "全ての試合、プロフィールデータ、ログイン情報が完全に削除されます。",
    "deleteForever": "はい、完全に削除します",
    "accountDeleted": "アカウントを削除しました",
    "handedness": "利き手",
    "righty": "右利き",
    "lefty": "左利き",
    "heightCm": "身長 ({{unit}})"
  },
  "cookies": {
    "title": "プライバシー",
    "intro": "このアプリが機能するために、また任意で利用状況を測定するためにCookieを使用しています。許可する項目を選択できます。",
    "necessary": "必須",
    "necessaryDesc": "サインインおよび主要な機能に必要です。常にオンになります。",
    "analytics": "アナリティクス",
    "analyticsDesc": "アプリを改善するための、匿名の利用統計です。",
    "marketing": "マーケティング",
    "marketingDesc": "広告ネットワークが広告をパーソナライズするために使用します。",
    "acceptAll": "すべてに同意する",
    "rejectAll": "すべて拒否する",
    "customize": "カスタマイズ",
    "savePrefs": "設定を保存する"
  },
  "invite": {
    "title": "友達を招待",
    "subtitle": "My Tennis Ledgerを共有 — QRコードをスキャンするか、リンクをコピーしてください。",
    "copyLink": "リンクをコピー",
    "share": "共有",
    "copied": "リンクをコピーしました！",
    "shareText": "My Tennis Ledgerであなたのテニスの戦績を記録しましょう:"
  },
  "help": {
    "eyebrow": "ヘルプセンター",
    "title": "Tennis Log の使い方",
    "subtitle": "スクリーンショットとヒントを交え、全ての機能を簡単にご紹介します。下のセクションをクリックすると、該当箇所にジャンプできます。",
    "tocTitle": "このページの目次",
    "tocTroubleshooting": "トラブルシューティング",
    "tocWhoFor": "Tennis Log はどんな人向け？",
    "tocAbout": "Tennis Log について",
    "s1Title": "はじめに",
    "s1Body": "メールアドレスまたはGoogleアカウントで会員登録します。登録完了後はダッシュボードが表示されますが、最初は空の状態です。「+ 新しい試合」をタップして、最初の試合を記録してみましょう。",
    "s2Title": "ダッシュボード",
    "s2Body": "上部には、勝率、セット、ゲーム、サービスキープ率、ブレーク獲得率、現在の調子という6つの概要が表示されます。それぞれに現在のフィルター（年、フォーマット、種類）が反映されます。その下には、勝率の推移と最近の試合が表示されます。",
    "s3Title": "試合の追加",
    "s3Body": "New Matchでは、まず対戦相手、コート、スコアを記録して結果を残します。その後、Score Timeline、Opponent、Context、Performance Review、Smartwatchを使って、実際に覚えている範囲だけ詳細を追加できます。まず基本の試合を保存し、後から同じ記録に戻って情報を補うこともできます。",
    "s4Title": "試合一覧",
    "s4Body": "対戦相手で検索したり、フォーマットや種類でフィルターをかけたりできます。各行をクリックすると編集が可能です。一括操作とCSVエクスポートは「設定」から行えます。",
    "s5Title": "スタッツ",
    "s5Body": "データを多角的に分析します：直接対決、コート別、サーフェス別、気温別、年/月別、対戦相手の年齢や経験別、ボールの状態別、さらには雨天やナイターでの試合まで分析可能です。",
    "s6Title": "AIインサイト",
    "s6Body": "「AIに質問」をクリックすると、試合履歴に基づいたコーチのような分析コメントが得られます。AI分析は試合データを記録すると利用でき、試合履歴が増えるほど、一般的により有益な内容になります。AI Insightsをリクエストすると、プライバシー保護のためにフィルタリングされ、許可リストに含まれる試合データのみが送信されます。個人識別情報はプライバシーポリシーに従って削除または仮名化されます。",
    "s7Title": "スマートウォッチからのインポート",
    "s7Body": "試合追加ページで「スマートウォッチデータ」までスクロールし、お使いのウォッチアプリのスクリーンショットをアップロードしてください。AIが消費カロリー（kcal）、試合時間、平均/最大心拍数（BPM）、心拍ゾーンを自動で入力します。",
    "s8Title": "エクスポートとアカウント削除",
    "s8Body": "「設定」からパスワードの変更、Cookieの管理、全データのCSVエクスポート、アカウントの完全な削除ができます。",
    "ctaTitle": "記録を始める準備はできましたか？",
    "ctaDesc": "簡単かつスピーディーに記録でき、最初の1試合を終えた直後からあなたのスタッツを確認できます。",
    "ctaBtn": "アカウントを作成する",
    "troubleshootingTitle": "トラブルシューティング",
    "troubleshootingItems": [
      { "q": "サインインできません", "a": "登録時と同じプロバイダー（メールまたはGoogle）を使用していることを確認してください。パスワードを忘れた場合は、サインイン画面のパスワードリセットリンクを使用してください。それでも解決しない場合は、フッターの「お問い合わせ」リンクから登録に使用したメールアドレスでご連絡ください。" },
      { "q": "試合が保存されませんでした", "a": "試合を保存するには、対戦相手とコートが必要です。スコアや追加情報は段階的に入力できます。赤いエラーメッセージが表示された場合は、不足している項目がフォームに示されます。ネットワークの問題でも保存できない場合があります。安定した接続で再度お試しください。" },
      { "q": "AIインサイトが生成されません", "a": "AIインサイトはパターンを見つけるために少なくとも数試合の記録が必要です。十分なデータがあってもエラーが出る場合、AIサービスが一時的にレート制限されている可能性があります — 1分待ってから再度お試しください。" },
      { "q": "スマートウォッチのスクリーンショットが解析されません", "a": "パーサーはApple Watch、Garmin、Polar、Fitbitからの鮮明でコントラストの高いスクリーンショットで最も効果を発揮します。ワークアウトサマリーの周りをタイトに切り取り、心拍数と時間のテキストが読み取れることを確認してください。" },
      { "q": "統計の数字がおかしく見えます", "a": "統計の意外な数字のほとんどは、game-by-game試合でのサーブ順の欠落から来ています — それがないと、アプリはホールドとブレイクを計算できません。試合を編集して、各セットで最初にサーブしたのが誰かを再確認してください。" }
    ],
    "whoTitle": "Tennis Logは誰のため？",
    "whoIntro": "Tennis Logは、帰り道にスコアを覚えているだけよりも、少し真剣にテニスに取り組みたいすべてのプレイヤーのために作られました。プレー歴が3か月でも30年でも同じように機能します — ツールの深さは、試合ログの深さに合わせて拡張されます。",
    "whoBeginnersTitle": "初心者",
    "whoBeginnersBody": "テニスを始めたばかりなら、Tennis Logが提供する最も有用なものは、最初の試合のシンプルで構造化された記録です。まだホールドとブレイクを追跡する必要はありません。対戦相手、スコア、サーフェス、1行のメモを記録するだけで十分です。10〜15試合後には、半年後に振り返って「明らかに上達した」と、感覚ではなく証拠とともに言えるベースラインができます。",
    "whoIntermediateTitle": "中級プレイヤー",
    "whoIntermediateBody": "クラブやリーグのプレイヤーにとって、Tennis Logは特に役立ちます。Game-by-gameの記録から実際のホールド率とブレーク率を確認できます。AI分析は試合データを記録すると利用でき、試合履歴が増えるほど、一般的により有益な内容になります。サーフェスや対戦相手のフィルターは違いの検討に役立ち、構造化された試合ログは練習やコーチとのセッションで取り組むべき質問を明確にします。",
    "whoCompetitiveTitle": "競技プレイヤー",
    "whoCompetitiveBody": "トーナメントや本格的なリーグで競技する場合、Tennis Logは個人パフォーマンスデータベースとして機能します。コンディション、対戦相手の利き手、両者の評価、スマートウォッチデータ、メンタルノートを記録 — そして結果の統計を年、サーフェス、種別（フレンドリー vs 公式）、パートナーなどで切り分けます。いつでもCSVにエクスポートして、コーチングセッションにデータを持ち込めます。"
  },
  "insightsH": {
    "overall": "全体の勝率",
    "overallDetail": "勝敗が決まった{{sample}}試合の勝率は{{rate}}%です。",
    "better": "相手より{{skill}}が格上",
    "betterDetail": "{{skill}}が相手より優れている場合、勝率は{{rate}}% ({{sample}}試合) です。ベースライン: {{baseline}}%。",
    "worse": "相手より{{skill}}が格下",
    "worseDetail": "{{skill}}が相手より劣っている場合、勝率は{{rate}}% ({{sample}}試合) です。",
    "condDetail": "{{sample}}試合で{{rate}}% (ベースライン {{baseline}}%)。",
    "cond": {
      "oneHanded": "片手バックハンドの相手",
      "twoHanded": "両手バックハンドの相手",
      "lowSleep": "睡眠不足(<6時間)",
      "goodSleep": "十分な睡眠(≥7時間)",
      "tiring": "疲労が溜まっている日",
      "floodlights": "ナイター照明下",
      "rainy": "雨天",
      "napped": "昼寝をした日",
      "heavyMeal": "食事を多くとった後",
      "fasted": "空腹時",
      "anxious": "不安を感じている時",
      "newBalls": "ニューボール",
      "official": "公式戦",
      "friendly": "練習試合",
      "singles": "シングルス",
      "doubles": "ダブルス",
      "surface": "サーフェス: {{surface}}"
    },
    "skill": {
    "shot_accuracy": "ショットの正確性",
    "call_accuracy": "判定の正確さ",
    "confrontational_tendency": "相手との衝突の少なさ",
      "forehand": "フォアハンド",
      "backhand": "バックハンド",
      "service": "サーブ",
      "return": "リターン",
      "volley": "ボレー",
      "drop_shot": "ドロップショット",
      "lob": "ロブ",
      "stamina": "スタミナ",
      "speed": "スピード",
      "unforced_errors": "ミスの抑制",
      "winners": "ウィナー",
      "tactics": "戦術",
      "awareness": "状況判断",
      "shot_variety": "ショットの多彩さ",
      "court_coverage": "コートカバー",
      "fh_topspin": "フォアのトップスピン",
      "fh_slice": "フォアのスライス",
      "bh_topspin": "バックのトップスピン",
      "bh_slice": "バックのスライス",
      "first_serve": "ファーストサーブ",
      "first_serve_pct": "ファーストサーブ確率",
      "first_serve_speed": "ファーストサーブの速度",
      "second_serve": "セカンドサーブ",
      "second_serve_pct": "セカンドサーブ確率",
      "second_serve_speed": "セカンドサーブの速度",
      "serve_flat": "フラットサーブ",
      "serve_kick": "キックサーブ",
      "serve_slice": "スライスサーブ",
      "smash": "スマッシュ",
      "passing_shots": "パッシングショット",
      "composure": "冷静さ（劣勢時）",
      "concentration": "集中力",
      "calmness": "落ち着き",
      "anxiety": "緊張のコントロール",
      "confidence": "自信",
      "fighting_spirit": "闘志",
      "mental_resilience": "精神的な回復力",
      "belief_pre": "試合前の自信",
      "belief_in": "試合中の自信"
    }
  },
  "days": [
    "日曜日",
    "月曜日",
    "火曜日",
    "水曜日",
    "木曜日",
    "金曜日",
    "土曜日"
  ]
};

data.quicklog = {
  "learnedAccordion": "Tennis Log がこれまでに学んだことを見る",
  "savedIndicator": "保存しました",
  "fastTrackEyebrow": "ファストトラック",
  "fastTrackTagline": "30秒以内で試合を記録。",
  "revealMore": "もっと豊かな答えが欲しい?下でさらに開く ↓",
  "bonus": "ボーナス",
  "continue": "続ける",
  "meterTitle": "Tennis Logは今、計算できます:",
  "meterSubtitle": "これらのインサイトは記録した試合に基づき、今すぐ利用できます。",
  "meterMoreTitle": "答えるためにさらに開く",
  "meterInfoAria": "これらのインサイトについて",
  "editScore": "スコアを編集",
  "timelineNoScore": "まだスコアが入力されていません",
  "answers": {
    "winRate": "総合勝率",
    "history": "試合履歴",
    "gamesPct": "ゲーム勝率 %",
    "setsPct": "セット勝率 %",
    "monthly": "月別勝率",
    "dayOfWeek": "曜日別勝率",
    "headToHead": "この相手との直接対決"
  },
  "future": {
    "opponent": "どのタイプの相手があなたのプレーに合うか",
    "timeline": "試合が実際にどう展開するか",
    "context": "どんな条件下でベストプレーができるか",
    "review": "あなたのどの技術が勝ちを呼ぶか",
    "watch": "スマートウォッチが示すあなたの運動負荷"
  },
  "stepTitles": {
    "fastTrack": "ファストトラック",
    "opponent": "対戦相手",
    "timeline": "スコア展開",
    "context": "コンテキストと条件",
    "review": "自己パフォーマンス評価",
    "watch": "スマートウォッチ"
  },
  "stepIntros": {
    "opponent": "対戦相手の情報を追加すると、Tennis Logは対戦相手像をより豊かに構築できます。より深い分析が可能になります。",
    "timeline": "各セットの展開を記録しましょう。試合パターンのより深い分析が可能になります。",
    "context": "試合の条件を記録しましょう。コンテキストのより深い分析が可能になります。",
    "review": "自分自身のパフォーマンスを評価しましょう。あなたの技術のより深い分析が可能になります。",
    "watch": "スマートウォッチをお持ちですか?スクリーンショットを1枚アップロードすればAIがすべて自動入力します。"
  },
  "stepUnlocksLabel": "以下の分析にデータを供給し始めます:",
  "unlocks": {
    "opponent": [
      "左利き相手との結果",
      "経験豊富な選手との結果",
      "相手のプレースタイル別の結果",
      "片手バックハンド相手との結果"
    ],
    "timeline": [
      "セットの勝ち方・負け方",
      "ブレークとキープのパターン",
      "セットをまたぐサーブの安定性"
    ],
    "context": [
      "条件がプレーに与える影響",
      "睡眠や休息が結果を変えるか",
      "天候とパフォーマンスの関係"
    ],
    "review": [
      "勝ちに相関する自分の技術",
      "試合を落とす原因となる弱点",
      "評価が時間とともにどう変化するか"
    ],
    "watch": [
      "カロリーと所要時間",
      "平均・最大心拍数",
      "トレーニング負荷と回復"
    ]
  },
  "successTitle": "試合を保存しました。",
  "successBody": "Tennis Logは、あなたのテニスについて次の問いにすでに答えられます:",
  "successCtaMatches": "試合一覧を見る",
  "successCtaContinue": "試合の詳細を追加（任意）",

  "addMoreDetails": "詳細を追加",
  "finish": "完了して保存",
  "wantRicher": "より豊かな答えが欲しいですか？",
  "prev": "戻る",
  "stepOf": "ステップ {{current}} / {{total}}",
  "dontShowRewards": "今後は表示しない",
  "canLabel": "Tennis Logはすでに次を把握できます:",
  "learnedLabel": {
    "match": "この試合からTennis Logが学んだこと:",
    "matches": "あなたの試合からTennis Logが学んだこと:",
    "tennis": "Tennis Logが知っているあなたのテニス:"
  },
  "hintLabel": "もう1分ありますか？",
  "rewardTitles": {
    "fastTrack": "試合を保存しました！",
    "timeline": "素晴らしい！",
    "opponent": "いいですね！",
    "context": "よくできました！",
    "review": "素晴らしい！"
  },
  "rewardBodies": {
    "fastTrack": "この試合はあなたのテニス履歴の一部になりました。",
    "timeline": "Tennis Logは試合の展開についてさらに深く理解できるようになりました。",
    "opponent": "Tennis Logは対戦相手についてさらに詳しく把握できるようになりました。",
    "context": "Tennis Logはあなたのパフォーマンスとプレー環境を結び付けられるようになりました。",
    "review": "パフォーマンス評価は、長期的な洞察のための貴重な情報源になります。"
  },
  "rewardHints": {
    "fastTrack": "次のステップを完了すると、Tennis Logは次のことを発見し始めます:",
    "timeline": "次は対戦相手について記録します。",
    "opponent": "次は試合のコンディションを記録します。",
    "context": "✨ あと1分だけありませんか？ それでは、両プレーヤーのパフォーマンスを評価していきましょう。",
    "review": "最後の任意のステップ: スマートウォッチを連携させましょう。"
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "相手の性別 *",
  "genderMale": "男性",
  "genderFemale": "女性",
  "genderOther": "その他",
  "oppLevel": "相手の総合レベル",
  "oppLevel1": "完全な初心者",
  "oppLevel5": "平均的なクラブプレーヤー",
  "oppLevel10": "今まで対戦した中で最強",
  "oppLevelHint": "7 = 強いクラブプレーヤー · 9 = 大会レベル",
  "oppBirthYear": "生年",
  "oppBirthMonth": "月",
  "oppBirthDay": "日",
  "oppTennisSince": "テニス開始年",
  "oppTennisSinceCompact": "テニス歴（開始年）",
  "oppLegacyValue": "以前の記録",
  "oppBirthInvalid": "生年は1900年以降の4桁で入力してください。",
  "oppAgePrev": "以前に記録された年齢",
  "oppExperiencePrev": "以前に記録された経験年数",
  "oppSinceBeforeBirth": "テニス開始年は生年より前にはできません。",
  "oppSinceFuture": "テニス開始年を未来に設定することはできません。",
  "oppSinceRange": "1900年以降の4桁の年を入力してください。",
  "oppStyleScore": "守備的 ↔ 攻撃的",
  "oppStyleLegacy": "以前の記録: {{value}}",
  "oppLevelAvg": "過去の試合の平均: {{value}}（{{n}}件）",
  "oppLevelHistory": "レベルの推移",
  "oppAttackTags": "相手の武器",
  "oppErrorTags": "相手のミスどころ",
  "oppTagRemembered": "以前の試合で記録",
  "attackGroup_serve": "サーブ・先手",
  "attackGroup_shape": "球質",
  "attackGroup_target": "狙い",
  "errorGroup_technical": "技術面",
  "errorGroup_situational": "状況面",
  "attackTag_big_first_serve": "強力なファーストサーブ",
  "attackTag_aggressive_return": "攻撃的なリターン",
  "attackTag_serve_volley": "サーブ&ボレー",
  "attackTag_takes_ball_early": "ライジングで打つ",
  "attackTag_heavy_topspin": "重いトップスピン",
  "attackTag_frequent_slice": "スライスが多い",
  "attackTag_drop_shots": "ドロップショット",
  "attackTag_short_angles": "ショートアングル",
  "attackTag_effective_lobs": "効果的なロブ",
  "attackTag_attacks_my_backhand": "私のバックを狙う",
  "attackTag_attacks_my_forehand": "私のフォアを狙う",
  "attackTag_net_rusher": "ネットに出る",
  "attackTag_open_court": "コートを広く使う",
  "attackTag_changes_direction": "方向を変える",
  "errorTag_backhand_breaks_down": "バックが崩れる",
  "errorTag_forehand_breaks_down": "フォアが崩れる",
  "errorTag_high_balls": "高い打点が苦手",
  "errorTag_low_balls": "低い球が苦手",
  "errorTag_vs_heavy_topspin": "重いスピンが苦手",
  "errorTag_vs_slice": "スライスが苦手",
  "errorTag_vs_drop_shots": "ドロップショットに弱い",
  "errorTag_volley_errors": "ボレーのミス",
  "errorTag_return_errors": "リターンのミス",
  "errorTag_second_serve_errors": "セカンドサーブが弱い",
  "errorTag_errors_when_rushed": "時間を奪われるとミス",
  "errorTag_errors_on_the_run": "走らされるとミス",
  "errorTag_overhits": "力み過ぎる",
  "errorTag_long_rallies": "ロングラリーでミス",
  "errorTag_under_pressure": "プレッシャーでミス",
  "oppLevelEmpty": "スライドして相手の総合レベルを評価してください。",
  "oppLevelDesc_10": "まったくの初心者",
  "oppLevelDesc_15": "習い始めたばかり",
  "oppLevelDesc_20": "試合経験の少ない初心者",
  "oppLevelDesc_25": "基本的な安定感を身につけ中",
  "oppLevelDesc_30": "たまに楽しむレクリエーション層",
  "oppLevelDesc_35": "上達中のレクリエーション層",
  "oppLevelDesc_40": "定期的にプレーするレクリエーション層",
  "oppLevelDesc_45": "安定したレクリエーション層",
  "oppLevelDesc_50": "平均的なクラブプレーヤー",
  "oppLevelDesc_55": "競技志向のクラブプレーヤー",
  "oppLevelDesc_60": "強いクラブプレーヤー",
  "oppLevelDesc_65": "非常に強いクラブプレーヤー",
  "oppLevelDesc_70": "上級クラブプレーヤー",
  "oppLevelDesc_75": "地域大会で強いプレーヤー",
  "oppLevelDesc_80": "高いレベルの大会プレーヤー",
  "oppLevelDesc_85": "非常に強い大会プレーヤー",
  "oppLevelDesc_90": "トップアマチュア／地域トップレベル",
  "oppLevelDesc_95": "並外れたプレーヤー",
  "oppLevelDesc_100": "これまで対戦した中で最高の選手",
  "oppAttackNotes": "この相手はどのように攻めてきますか？",
  "oppAttackNotesPlaceholder": "例: 強力なサーブ、早いタイミングで打つ…",
  "oppErrorNotes": "この相手はどのようにミスをしますか？",
  "oppErrorNotesPlaceholder": "例: バックハンドを攻められると崩れる…"
});
data.quicklog.stepTitles.review = "プレーヤー評価";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "必要最低限だけ。約30秒で完了します。",
  "timeline": "試合はどのように展開しましたか？",
  "opponent": "対戦相手について少し教えてください。",
  "context": "細部が違いを生みます。",
  "review": "両プレーヤーのパフォーマンスを評価しましょう。やがてTennis Logがあなたの勝因を見つけ出します。",
  "watch": "スマートウォッチをお持ちですか？残りはTennis Logにお任せください。"
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "完璧です！",
  "timeline": "素晴らしい！",
  "opponent": "いいですね！",
  "context": "完璧です！",
  "review": "素晴らしい仕事です！",
  "watch": "これで完了です！"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "この試合はあなたのテニスヒストリーの一部になりました。",
  "timeline": "Tennis Logはあなたの試合展開をより深く理解できるようになりました。",
  "opponent": "Tennis Logは対戦相手についてより多くを知りました。",
  "context": "あなたの個人データベースはさらに賢くなりました。Tennis Logはパフォーマンスとコンディションを結び付け始めます。",
  "review": "あなたと相手のプレーヤープロフィールが大きく充実しました。Tennis Logはどのスキルが勝利をもたらすかを発見し始めます。",
  "watch": "テニス人生でもっとも充実した試合記録のひとつが完成しました。Tennis Logがあなたのテニスを理解する手助けをありがとうございます。"
});

data.guest = {
  "tryNow": "今すぐ試す — アカウント不要",
  "tryNowLine1": "今すぐ試す",
  "tryNowLine2": "アカウント不要",
  "badge": "ゲストセッション",
  "sumScore": "スコア",
  "sumType": "試合形式",
  "saveTitle": "最初の試合が完成しました。",
  "saveSubtitle": "すでに最初の試合を記録しました。無料アカウントを作成すると、永久に保存してテニス履歴を築き始められます。",
  "canTitle": "Tennis Logはすでに次を計算できます",
  "beginningTitle": "これはまだ始まりにすぎません。",
  "beginningBody": "続ければ、Tennis Logはあなたの試合からさらに多くを学びます。",
  "google": "Googleで続行",
  "createAccount": "アカウントを作成",
  "haveAccount": "すでにアカウントを持っています",
  "editAgain": "この試合を編集",
  "whyLink": "なぜアカウントが必要ですか？",
  "whyBody": "あなたの試合はあなたのものです。アカウントがあると Tennis Log は次のことができます:",
  "whyB1": "履歴を保存する",
  "whyB2": "デバイス間で同期する",
  "whyB3": "長期的な統計を作る",
  "whyB4": "AIインサイトを生成する",
  "persisting": "試合を保存しています…",
  "successTitle": "完璧です！",
  "successBody": "最初の試合があなたのテニス履歴の一部になりました。",
  "successContinue": "試合の詳細を追加（任意）"
};

data.appWelcome = {
  "heading": "Tennis Log へようこそ",
  "subheading": "あなたのテニスの記録は、次の試合から始まります。",
  "googleCta": "Google で続ける",
  "googleHelper": "すばやく安全に。新しいパスワードは不要です。",
  "guestCta": "アカウントなしで始める",
  "guestHelper": "今すぐ最初の試合を記録しましょう。データは後から Google で保護できます。",
  "haveAccount": "すでにアカウントをお持ちですか？ ログイン",
  "carouselTitle": "25試合で何が見えてくる？",
  "carouselSubtitle": "記録するほど、あなたのテニスがはっきり見えてきます。",
  "carouselTitle2": "Tennis Log は試合ごとに育ちます",
  "carouselSubtitle2": "スワイプして、statistics がどう育つか見てみましょう。",
  "card4": "運動量・消費カロリー・心拍数",
  "card5": "カレンダーで見る試合",
  "card1": "シーズン全体をひと目で",
  "card2": "プレーの成長を確認",
  "card3": "ひとりでは気づけない傾向を発見",
  "footer": "基本機能は無料 • データはあなたのもの • クラブプレーヤーのために",
  "prev": "前へ",
  "next": "次へ",
  "mini": {
    "winRate": "勝率",
    "matches": "試合数",
    "sets": "獲得セット",
    "trend": "勝率の推移",
    "you": "あなた",
    "opponent": "相手",
    "serve": "サーブ",
    "forehand": "フォアハンド",
    "backhand": "バックハンド",
    "movement": "フットワーク",
    "strength": "強み",
    "strengthBody": "先にブレークした試合では78%勝っています。",
    "opportunity": "改善の余地",
    "opportunityBody": "第3セットでバックハンドの評価が下がります。体力か集中の傾向です。"
  }
};

data.consent = { "health": { "title": "健康データ — 明示的な同意", "body": "心拍数、心拍ゾーン、消費カロリー、運動時間、スマートウォッチのスクリーンショットは健康データです。Tennis Log は、あなたが明示的に許可した場合にのみ、AI プロバイダーへの送信を含めてこれらを処理します。任意であり、設定からいつでも撤回でき、その際は保存済みの健康データが削除されます。", "checkbox": "上記のとおり、Tennis Log が私の健康データを処理することに明示的に同意します。", "enable": "健康データを有効にする", "optional": "任意 — 健康データなしでも Tennis Log は完全に利用できます。", "granted": "健康データを有効にしました。", "stale": "同意文が更新されました。ページを再読み込みしてご確認ください。", "error": "選択を保存できませんでした。もう一度お試しください。", } };

data.share = {
  button: "結果をシェア",
  dialogTitle: "結果をシェア",
  dialogSubtitle: "この試合の画像をSNS用に作成します。アップロードはされません — 画像は端末上で生成されます。",
  showNames: "他の選手の名前を表示",
  showLocation: "場所を表示",
  saveImage: "画像を保存",
  shareImage: "シェア",
  working: "作成中…",
  saved: "画像を保存しました。",
  shared: "シェアしました。",
  failed: "画像を作成できませんでした。もう一度お試しください。",
  shareUnsupported: "この端末では画像をシェアできません — 「画像を保存」をご利用ください。",
  you: "あなた",
  yourTeam: "あなたのチーム",
  opponent: "対戦相手",
  opposingTeam: "相手チーム",
  victory: "勝利",
  defeat: "敗北",
  draw: "引き分け",
  retired: "途中棄権",
  incomplete: "未完了",
  retiredTag: "棄権",
};

export default data;
